import { useState } from "react";
import { legeErstenAdminAn } from "../api.js";

/**
 * Erstinbetriebnahme. Erscheint nur, solange noch kein Benutzer existiert —
 * danach weist der Server den Endpunkt dauerhaft ab.
 *
 * Es gibt diesen Weg, weil die Datenbank in einem Durable Object liegt und
 * sich nicht mehr von außen per CLI befüllen lässt.
 */
export function Ersteinrichtung({ beiFertig }: { beiFertig: () => void }) {
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [passwort, setPasswort] = useState("");
  const [wdh, setWdh] = useState("");
  const [fehler, setFehler] = useState<string | null>(null);
  const [laeuft, setLaeuft] = useState(false);

  async function absenden(e: React.FormEvent) {
    e.preventDefault();
    setFehler(null);
    if (passwort.length < 12)
      return setFehler("Das Passwort muss mindestens 12 Zeichen haben.");
    if (passwort !== wdh) return setFehler("Die beiden Passwörter stimmen nicht überein.");

    setLaeuft(true);
    try {
      await legeErstenAdminAn(email, name, passwort);
      beiFertig();
    } catch (err) {
      setFehler(err instanceof Error ? err.message : "Einrichtung fehlgeschlagen.");
    } finally {
      setLaeuft(false);
    }
  }

  return (
    <div className="anmelde-seite">
      <form className="anmelde-karte" onSubmit={absenden} style={{ maxWidth: 440 }}>
        <img src="/logo-engelke.png" alt="Gebr. Engelke — Große Mühle seit 1714" />

        <div className="meldung hinweis" style={{ marginBottom: "1.4rem" }}>
          Diese Anwendung ist noch nicht eingerichtet. Legen Sie jetzt das
          Administratorkonto an — danach ist dieser Schritt dauerhaft gesperrt.
        </div>

        {fehler && (
          <div className="meldung fehler" role="alert">
            {fehler}
          </div>
        )}

        <div className="feld">
          <label htmlFor="s-name">Name</label>
          <input
            id="s-name"
            required
            autoFocus
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="feld">
          <label htmlFor="s-mail">E-Mail</label>
          <input
            id="s-mail"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="feld">
          <label htmlFor="s-pw">Passwort</label>
          <input
            id="s-pw"
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            maxLength={128}
            value={passwort}
            onChange={(e) => setPasswort(e.target.value)}
          />
          <p className="hinweistext">
            Mindestens 12 Zeichen. Länge zählt mehr als Sonderzeichen — vier zufällige Wörter
            sind eine gute Wahl.
          </p>
        </div>
        <div className="feld">
          <label htmlFor="s-wdh">Passwort wiederholen</label>
          <input
            id="s-wdh"
            type="password"
            autoComplete="new-password"
            required
            maxLength={128}
            value={wdh}
            onChange={(e) => setWdh(e.target.value)}
          />
        </div>

        <button className="knopf" type="submit" disabled={laeuft}>
          {laeuft ? "Wird eingerichtet …" : "Administrator anlegen"}
        </button>
      </form>
    </div>
  );
}
